import React, { Component } from "react";

import GameController from "../GameController";
import VideoOffNotice from "../VideoOffNotice";
import LottoVirtualBalls from "../LottoVirtualBalls";
import SamGongVirtualBalls from "../SamGongVirtualBalls";
import StreamingQualityButton from "../StreamingQualityButton";

import thousandsFormat from "@/modules/thousandsFormat";

import {
	isBetClosed,
	getTranslatedGameName,
	GameStatistics,
	History,
	RoadmapLarge,
	RoadmapSmall,
	Table,
	isDev,
	isBigChipGame,
	isNullOrEmpty,
} from "@/modules/commonMobile";

import { assetImg } from "@/modules/moduleImporter";

// /assets/img/svg/buttons
import img_small_fullscreen from "@/assets/img/svg/sidemenu/fullscreen.svg";
import img_multibet_restore from "@/assets/img/svg/buttons/restore.svg";

import small_history_on from "@/assets/img/small_history_on.png";
import small_history_off from "@/assets/img/small_history_off.png";
import small_roadmap_on from "@/assets/img/small_roadmap_on.png";
import small_roadmap_off from "@/assets/img/small_roadmap_off.png";
import small_minmax_on from "@/assets/img/small_minmax_on.png";
import small_minmax_off from "@/assets/img/small_minmax_off.png";

import img_bet_closed_multi_table from "@/assets/img/img_bet_closed_multi_table.png";

import { IMaximisedGameProps } from "@/types/GlobalTypes";
import zeroFill from "@/modules/zeroFill";
import { renderModals } from "@/modules/modals";
import { getAssetPcode, getBasePcode, getClonePcode } from "@/modules/gamePcode";
import { hasHDStreaming } from "@/modules/videoQuality";
import { isHistoryOnlyGame } from "../../modules/commonMobile";

interface IState {
	winNumberGif: JSX.Element;
	winNumberGifs: JSX.Element[];
}

export default class MaximizeGame extends Component<IMaximisedGameProps, IState> {
	win: any;

	constructor(props: IMaximisedGameProps) {
		super(props);

		this.state = {
			winNumberGif: null,
			winNumberGifs: null
		};
	}

	componentDidUpdate(prevProps: IMaximisedGameProps, prevState: IState) {
		const activeGame = this.props.data;
		const { pcode } = activeGame;
		const basePcode = getBasePcode(pcode);
		const clonePcode = getClonePcode(pcode);
		const assetPcode = getAssetPcode(clonePcode);

		//Only evaluate active games
		if (activeGame.active) {
			// console.log("wins: " + activeGame.win, prevProps.activeGame.win);
			if (this.win !== activeGame.win) {
				// const winNumberGif = activeGame.win_number_gif;
				const win = activeGame.win;
				let wins: any[];

				window.setTimeout(() => {
					const dom = document.getElementById("wng_" + basePcode);
					if (dom !== null)
						dom.className += " appear";
				}, 100);

				console.log(pcode + " win: " + win);

				// console.log(pcode + " win gif", winNumberGif, winNumberGif[win] + "?a=" + Math.random());

				this.win = win;

				if (!win) return;

				switch (pcode) {
					case "m7":  // oglok
					case "m10": // head & tail
					case "m11": // red white
					case "m19": // suwit
					case "p12": // sicbo dice
					case "m31": // 3D (sicbo machine)
					case "m32": // Samgong
					case "m33": // Gong Ball Jitu
					case "m37": // singon sicbo 
					case "m39": // Duel Dice
						wins = win.split(",");
						this.setState({
							winNumberGifs:
								wins.map((item: string, idx: number) =>
									assetImg("win_number_gif_" + assetPcode,
										item + ".gif?a=" + Math.random(),
										"ohrss_" + pcode + "_" + idx)
								)
						});
						break;

					case "m13": //Billiards
						this.setState({
							winNumberGif: assetImg("win_number_gif_" + assetPcode,
								win.win + ".gif?a=" + Math.random())
						});
						break;

					case "m14": //Poker Dice
						wins = win.angka2.split(",");
						this.setState({
							winNumberGifs:
								wins.map((item, idx) =>
									assetImg("win_number_gif_" + assetPcode,
										item + ".gif?a=" + Math.random(),
										"ohrss_" + pcode + "_" + idx)
								)
						});
						break;
					case "m16": //Gong Ball
						if (!win || win === "")
							break;

						wins = (
							win.result === "Banker" ?
								win.angka1 : win.angka2
						).split(",");

						wins = wins.map(item => item === "1" ? "A" : item);

						this.setState({
							winNumberGifs:
								wins.map((item, idx) =>
									assetImg("win_number_gif_" + assetPcode,
										item + ".gif?a=" + Math.random(),
										"ohrss_" + pcode + "_" + idx)
								)
						});
						break;
					default:
						this.setState({
							winNumberGif: assetImg("win_number_gif_" + assetPcode,
								win + ".gif?a=" + Math.random())
						});
						break;
				}
			}
		}
	}

	/**
	 * Only for Duel Dice
	 */
	get moreBetButtonFragment() {
		const { maximised } = this.activeGame;
		const { completeTable } = this.props;

		if (!maximised || this.pcode !== "m39")
			return null;

		const label = completeTable
			? "Less Bet"
			: "More Bet";

		return (
			<button
				className="toggle-more-bet"
				onClick={this.props.toggleCompleteTable}>
				<img
					src="assets/img/more_less_buttons/btn_more_less_inverted.png"
					alt="more/less" />
				<p>{label}</p>
			</button>
		);
	}

	private get secondsLeft() {
		const { timerData } = this.props;
		return timerData ? timerData.time : 0;
	}

	/**
	 * Get time left in string
	 */
	private get timeText() {
		const timer = this.secondsLeft;
		const min = Math.floor(timer / 60);
		const sec = timer % 60;
		return min + ":" + zeroFill(sec, 2);
	}

	private get activeGame() {
		return this.props.data;
	}

	private get pcode() {
		return this.activeGame.pcode;
	}

	private get basePcode() {
		return getBasePcode(this.pcode);
	}

	private get specialStatisticsTab() {
		return /(m7|m19|m39)/.test(this.basePcode);
	}

	private get streamObj() {
		return this.activeGame.streamObj;
	}

	private get historyProperty() {
		return this.activeGame.history || [];
	}

	private get historyBlink() {
		return this.activeGame.historyBlink;
	}

	private get pcodeProp() {
		const { pcode } = this.activeGame;
		return ({ pcode });
	}

	private get gamePcodeProp() {
		return (
			{ game: this.activeGame.pcode }
		);
	}

	private get headerFragment() {
		const { lang } = this.props;
		const { activeGame } = this;
		const pcode = activeGame.pcode;
		const pcodeProp = { pcode };
		const assetPcode = getAssetPcode(pcode);

		const activeGamePcodes = this.props.activeGamePcodes || [];

		return (
			<div className="header">
				{assetImg("game_icon", assetPcode + "_wh.svg", "", "logo")}

				<p className="name">
					{getTranslatedGameName(lang, pcode)}
				</p>

				<p className="periode">
					P {activeGame.periode}
				</p>

				{
					!activeGame.maximised ?
						<img className={"maximise"}
							src={img_small_fullscreen}
							{...pcodeProp}
							onClick={this.props.maximiseGame}
							alt="maximise" />
						: null
				}

				{
					activeGamePcodes.length > 0 &&
						activeGame.maximised ?

						<img className="restore"
							src={img_multibet_restore}
							{...pcodeProp}
							//Restores minimised games
							onClick={this.props.restoreGames}
							alt="restore" />
						: null
				}

				{/* <i className={"sl-ic-close close"}
					{...this.gamePcodeProp}
					onClick={this.props.closeGame} /> */}
			</div>
		);
	}

	private get streamingFragment() {
		const { streamObj } = this;

		const {
			enableStreaming,
			lang,
			isLoadingStreaming
		} = this.props;

		return (
			<div className={"stream-container" +
				(enableStreaming ? " has-streaming" : " no-streaming")}>

				{enableStreaming ? streamObj : null}

				<VideoOffNotice
					langdata={lang}
					enableStreaming={enableStreaming}
					isLoadingStreaming={isLoadingStreaming}
					isDesktop={true}
				/>
			</div>
		);
	}

	private get streamingQualityButtonFragment() {
		const { activeGame } = this;
		const { userdata } = this.props;

		return (
			isDev() &&
				activeGame.maximised &&
				userdata.user.enableStreaming &&
				hasHDStreaming(activeGame) ? (
				<StreamingQualityButton
					quality={this.props.videoQuality}
					changeQuality={this.props.changeVideoQuality} />
			) : null
		);
	}

	/**
	 * Animated winning numbers
	 */
	private get winNumberGifFragment() {
		const { win } = this.activeGame;

		if (isNullOrEmpty(win))
			return null;

		const { lang } = this.props;
		const { winNumberGif, winNumberGifs } = this.state;

		return (
			<div id={"wng_" + this.basePcode}
				className="win-number-gif">
				<p>
					{lang["txt_result"]}
				</p>

				{winNumberGif}
				{winNumberGifs}
			</div>
		);
	}

	private get betClosed() {
		return isBetClosed(this.secondsLeft);
	}

	private get multiTableRoadmapFragment() {
		if (!this.multiTable || !this.activeGame.lobbyRoadmap)
			return null;

		const { historyProperty, pcode, pcodeProp } = this;
		const { historyBlink, activeRoadmapFilter, roadmapFilters } = this.activeGame;
		const { lang } = this.props;

		return (
			this.isSamGong
				? (
					<RoadmapSmall
						langdata={lang}
						pcode={pcode}
						history={historyProperty}
						historyBlink={historyBlink}
						filter={activeRoadmapFilter} />
				) : (
					<div className={
						roadmapFilters.length === 1
							? "fullsize"
							: "normalsize"
					}>

						<RoadmapSmall
							langdata={lang}
							{...pcodeProp}
							small={true}
							history={historyProperty}
							historyBlink={historyBlink}
							filter={activeRoadmapFilter}
						/>
					</div>
				)
		);
	}

	/**
	 * Roadmap options
	 * Apply roadmap filter on click
	 * Skip render for single roadmap filter & pcodes: m7 & m19
	 */
	private get multiTableRoadmapOptionsFragment() {
		if (!this.multiTable ||
			!this.activeGame.lobbyRoadmap ||
			this.activeGame.roadmapFilters.length === 1 ||
			/^(m7|m19)$/.test(this.pcode))
			return null;

		const { gamePcodeProp } = this;
		const {
			roadmapFilters,
			alwaysShowRoadmapText,
			roadmapText,
			activeRoadmapFilter
		} = this.activeGame;

		const { setLobbyRoadmapFilter } = this.props;

		return (
			<div className={"roadmap-options tip"}>
				{
					roadmapFilters.map((filter, idx) => (
						<div key={filter.replace(" ", "_")}
							className={activeRoadmapFilter === filter ? "active" : ""}
							{...{ ...gamePcodeProp, filter }}
							onClick={setLobbyRoadmapFilter}>
							<div>{idx + 1}</div>
						</div>)
					)
				}


				<span className={alwaysShowRoadmapText ? "active" : ""}>
					{roadmapText[activeRoadmapFilter]}
				</span>
			</div>
		);
	}

	private get multiTableMinMaxHistoryFragment() {
		if (!this.multiTable)
			return null;

		const { lobbyHistory, lobbyMinMax } = this.activeGame;

		return (
			lobbyMinMax
				? this.multiTableMinMaxFragment
				: lobbyHistory
					? this.multiTableHistoryFragment
					: null
		);
	}

	private get multiTableMinMaxFragment() {
		const { activeGame } = this;
		const { lang, userdata } = this.props;

		return (
			<div className="min-max-container">
				<table className="table-desc">
					<tbody>
						<tr>
							<td className="desc-heading">{lang["txt_min_number"]}</td>
							<td>:</td>
							<td className="desc-content">{thousandsFormat(activeGame.min, userdata.user.lang)}</td>
						</tr>
						<tr>
							<td className="desc-heading">{lang["txt_min_50"]}</td>
							<td>:</td>
							<td className="desc-content">{thousandsFormat(activeGame.min50, userdata.user.lang)}</td>
						</tr>
						<tr>
							<td className="desc-heading">{lang["txt_max_number"]}</td>
							<td>:</td>
							<td className="desc-content">{thousandsFormat(activeGame.max, userdata.user.lang)}</td>
						</tr>
						<tr>
							<td className="desc-heading">{lang["txt_max_50"]}</td>
							<td>:</td>
							<td className="desc-content">{thousandsFormat(activeGame.max50, userdata.user.lang)}</td>
						</tr>
					</tbody>
				</table>
			</div>
		);
	}

	private get multiTableHistoryFragment() {
		const { pcodeProp, historyProperty, activeGame } = this;
		const { activeGameCount, lang } = this.props;

		return (
			<History
				{...pcodeProp}
				history={historyProperty}
				historyBlink={activeGame.historyBlink}
				activeGameCount={activeGameCount}
				langdata={lang}
			/>
		);
	}

	/**
	 * Table at the right side of streaming
	 */
	private get singleGameTableDescFragment() {
		if (!this.singleGame)
			return null;

		const { activeGame } = this;
		const { lang, userdata } = this.props;

		return (
			<table className="table-desc">
				<tbody>
					<tr>
						<td className="desc-heading"><div>{lang["txt_table_name"]}</div></td>
						<td className="desc-content"><div>{userdata.user.table}</div></td>
					</tr>
					{/* Todo: work on this later */}
					<tr>
						<td className="desc-heading"><div>{lang["txt_periode"]}</div></td>
						<td className="desc-content"><div>{activeGame.periode}</div></td>
					</tr>
					<tr className="table-limit-bet">
						<td colSpan={2}
							style={{ textAlign: "center" }}
							className="desc-heading">
							{lang["txt_bet_limit"]}
						</td>
					</tr>
					<tr>
						<td style={{ textAlign: "center" }}>
							<div className="desc-heading">{lang["txt_min_number"]}</div>
							<div className="desc-content">{thousandsFormat(activeGame.min, userdata.user.lang)}</div>
						</td>
						<td style={{ textAlign: "center" }}>
							<div className="desc-heading">{lang["txt_max_number"]}</div>
							<div className="desc-content">{thousandsFormat(activeGame.max, userdata.user.lang)}</div>
						</td>
					</tr>
					<tr>
						<td style={{ textAlign: "center" }}>
							<div className="desc-heading">{lang["txt_min_50"]}</div>
							<div className="desc-content">{thousandsFormat(activeGame.min50, userdata.user.lang)}</div>
						</td>
						<td style={{ textAlign: "center" }}>
							<div className="desc-heading">{lang["txt_max_50"]}</div>
							<div className="desc-content">{thousandsFormat(activeGame.max50, userdata.user.lang)}</div>
						</td>
					</tr>
					<tr>
						<td colSpan={2} style={{ textAlign: "center" }}>
							<div className="desc-heading">{lang["txt_detail"]}</div>
							<div className="desc-content">1K = {thousandsFormat(1000, userdata.user.lang)}</div>
						</td>
					</tr>
				</tbody>
			</table>
		);
	}

	private get gameTableFragment() {
		const { activeGame, betClosed } = this;

		const {
			insertBet,
			chipBase,
			lang
		} = this.props;

		return (
			<div className="table">
				<Table data={activeGame}
					isBetClosed={betClosed}

					{...this.pcodeProp}

					insertBet={insertBet}
					chipBase={chipBase}
					langdata={lang}
					maximised={activeGame.maximised}
					completeTable={this.props.completeTable}

					showHiddenMultibet={this.props.showHiddenMultibet}
				/>
			</div>
		);
	}

	private get gameControllerFragment() {
		const { activeGame, pcodeProp } = this;
		const { lang } = this.props;

		return (
			<div className="controller">
				<GameController
					disabled={activeGame.disableUndoBet}
					clickFunction={this.props.undoBet}
					controllerClass={"sl-red-sh"}
					{...pcodeProp}
					controllerValue={lang["txt_undo"]} />

				<GameController
					disabled={activeGame.disableClearBet}
					clickFunction={this.props.clearBet}
					controllerClass={"sl-blue-sh"}
					{...pcodeProp}
					controllerValue={lang["txt_clear"]} />

				<GameController
					disabled={activeGame.disableRebet}
					clickFunction={this.props.reBet}
					controllerClass={"sl-yellow-sh"}
					{...pcodeProp}
					controllerValue={lang["txt_rebet"]} />

				<GameController
					disabled={activeGame.disableSubmitBet}
					clickFunction={this.props.sendBet}
					controllerClass={"sl-green-sh"}
					{...pcodeProp}
					controllerValue={lang["txt_submit"]} />
			</div>
		);
	}

	/**
	 * Virtual Ball Fragment for Sicbo Machine & Bingo Sicbo
	 */
	private get sicboMachineVirtualBallFragment() {
		if (!["m31", "m37"].includes(this.pcode) || !this.activeGame.lottoResult)
			return null;

		const { activeGame } = this;
		const { lang } = this.props;

		return (
			<LottoVirtualBalls
				activeGame={activeGame}
				langdata={lang}
				lottoResult={activeGame.lottoResult}
			/>
		);
	}

	private get samGongVirtualBallFragment() {
		if (!this.isSamGong || !this.activeGame.lottoResult)
			return null;

		const { activeGame } = this;
		const { lang } = this.props;

		return (
			<SamGongVirtualBalls
				activeGame={activeGame}
				langdata={lang}
				lottoResult={activeGame.lottoResult}
			/>
		);
	}


	private get singleGame() {
		return this.props.activeGameCount === 1;
	}

	private get multiTable() {
		return this.props.activeGameCount > 1;
	}

	private get isSamGong() {
		return this.pcode === "m32";
	}

	/**
	 * Roadmap container will be used on games with roadmap filter
	 */
	private get roadmapContainerFragment() {
		if (!this.singleGame)
			return null;

		const {
			activeGame,
			historyBlink,
			historyProperty,
			isSamGong,
			pcode
		} = this;

		return (
			<div className="roadmap-container">
				{
					//Roadmap Tabs
					!isSamGong ?
						<table className="roadmap-tabs">
							<tbody>
								<tr>
									{
										activeGame.roadmapFilters.length > 0 ? (
											activeGame.roadmapFilters.map((key, idx) =>
												<td key={`rcrt_${idx}`}
													className={"roadmap-tab " +
														(activeGame.activeRoadmapFilter === key ? "active" : "")
													}
													{
													...{
														game: pcode,
														filter: key
													}
													}
													onClick={this.props.setLobbyRoadmapFilter}>
													{
														activeGame.roadmapText ?
															activeGame.roadmapText[key] : null
													}
												</td>
											)) : null
									}
								</tr>
							</tbody>
						</table> : null
				}

				{
					//The usual roadmap
					!isSamGong ? (
						<RoadmapLarge
							{...this.pcodeProp}
							historyBlink={historyBlink}
							history={historyProperty}
							filter={activeGame.activeRoadmapFilter}
						/>
					) : null
				}

				{
					//Roadmap for SamGong
					isSamGong ?
						["big-road", "big-eye-road", "small-road", "cockroach-road"].map(item =>
							<RoadmapLarge
								key={"SG_roadmap_" + item}
								pcode={activeGame.pcode}
								history={historyProperty}
								filter={activeGame.activeRoadmapFilter}
								historyBlink={activeGame.historyBlink}
								baccaratDarkMode={this.props.baccaratDarkMode}
								type={item} />
						)
						: null
				}
			</div>
		);
	}

	private get totalBetWinFragment() {
		const { singleGame } = this;
		const { totalBet, totalWin } = this.activeGame;
		const { lang, userdata } = this.props;
		const langToken = userdata.user.lang;

		return (
			<div className="details">
				<div className="total-bet">
					<p className="desc-heading">
						{lang["txt_total_bet"]}
					</p>
					<p className="desc-content">
						{thousandsFormat(totalBet, langToken)}
					</p>
				</div>

				{
					singleGame ? (
						<div className="total-win">
							<p className="desc-heading">
								{lang["txt_total_win"]}</p>
							<p className="desc-content">
								{thousandsFormat(totalWin, langToken)}
							</p>
						</div>
					) : null
				}
			</div>
		);
	}

	private get gameTimerFragment() {
		const { betClosed, singleGame, timeText } = this;
		const { lang } = this.props;

		const timeLeftClassNames = [
			"timer",

			betClosed
				? "bet-closed"
				: this.secondsLeft > 5
					? "bet-open"
					: "bet-closing"
		].join(" ");

		return (
			<div className="group-timer">
				{
					singleGame ? (
						betClosed
							? (
								<div className="bet-closed-text">
									{lang["txt_wait_next_round"]}
								</div>
							) : this.secondsLeft > 5
								? <div className="bet-open-text">
									{lang["txt_place_bet"]}
								</div>
								: <div className="bet-closing-text">
									{lang["txt_bet_close_in"]}
								</div>
					) : null
				}

				<div className={timeLeftClassNames}>
					{
						betClosed ?
							<img src={img_bet_closed_multi_table} alt="bet closed" /> :
							timeText
					}
				</div>
			</div>
		);
	}

	private get hideStatisticsTab() {
		const { basePcode } = this;
		return /(m7|m19|m33|m39)/.test(basePcode);
	}

	/**
	 * History and Statistics fragment for single game
	 */
	private get singleGameHistoryStatisticsFragment() {
		if (!this.singleGame)
			return null;

		const { activeGame, hideStatisticsTab, pcode, historyBlink, historyProperty, pcodeProp } = this;
		const {
			lang,
			toggleLobbyHistory,
			toggleGameStatistics
		} = this.props;

		return (
			<div className="history-statistics-container">
				<table className="roadmap-tabs">
					<tbody>
						<tr>
							<td {...pcodeProp}
								className={"roadmap-tab" + (activeGame.lobbyHistory ? " active" : "")}
								onClick={toggleLobbyHistory}>
								{lang["txt_history"]}
							</td>

							{/* statistics container except m7 and m19 */}
							{
								!hideStatisticsTab ? (
									<td {...pcodeProp}
										className={"roadmap-tab" + (activeGame.lobbyStatistics ? " active" : "")}
										onClick={toggleGameStatistics}>
										{lang["txt_statistics"]}
									</td>) : null
							}
						</tr>
					</tbody>
				</table>

				{
					activeGame.lobbyHistory ?
						this.isSamGong ?
							<RoadmapLarge
								pcode={activeGame.pcode}
								history={historyProperty}
								filter={activeGame.activeRoadmapFilter}
								historyBlink={activeGame.historyBlink}
								baccaratDarkMode={this.props.baccaratDarkMode}
								enlarged={false}
								type="bead-road" />
							:
							<History
								{...pcodeProp}
								history={historyProperty}
								historyBlink={historyBlink}
								activeGameCount={this.props.activeGameCount}
								langdata={lang}
							/> : null
				}

				{
					activeGame.lobbyStatistics ?
						<GameStatistics
							{...pcodeProp}
							history={historyProperty}
							filters={activeGame.roadmapFilters}
							langdata={lang}
						/> : null
				}

				{
					//Predictions for SamGong is inside Statistics
					this.isSamGong &&
						activeGame.lobbyStatistics ?
						<RoadmapLarge
							pcode={pcode}
							history={historyProperty}
							historyBlink={activeGame.historyBlink}
							filter={activeGame.activeRoadmapFilter}
							type="predictions" /> : null
				}
			</div>
		);
	}

	/**
	 * Special statistics container for m7 and m19
	 */
	private get singleGameSpecialStatisticsFragment() {
		if (!this.singleGame || !isHistoryOnlyGame(this.basePcode))
			return null;

		const {
			activeGame,
			historyProperty,
			specialStatisticsTab,
			pcodeProp
		} = this;
		const { lang } = this.props;

		return (
			<div className={"history-statistics-container " +
				(specialStatisticsTab ? "m7-m19" : "m33")
			}>
				<table className="roadmap-tabs">
					<tbody>
						<tr>
							<td {...pcodeProp} className={"roadmap-tab active"}>
								{lang["txt_statistics"]}
							</td>
						</tr>
					</tbody>
				</table>
				<GameStatistics
					{...pcodeProp}
					history={historyProperty}
					filters={activeGame.roadmapFilters}
					langdata={lang}
				/>
			</div>
		);
	}

	private get multiTableHistoryButtonFragment() {
		if (!this.multiTable)
			return null;

		const { basePcode, pcodeProp } = this;
		const { lobbyRoadmap, lobbyHistory, lobbyMinMax } = this.activeGame;

		const {
			toggleLobbyRoadmap,
			toggleLobbyHistory,
			toggleLobbyMinMax
		} = this.props;

		const historyOnlyGame = isHistoryOnlyGame(basePcode);

		return (
			<div className="game-history-buttons">
				{
					// Roadmap button
					!historyOnlyGame ? (
						<div {...pcodeProp} onClick={toggleLobbyRoadmap}>
							{
								lobbyRoadmap ?
									<img src={small_roadmap_on} alt="roadmap" /> :
									<img src={small_roadmap_off} alt="roadmap" />
							}
						</div>) : null
				}

				<div {...pcodeProp} onClick={toggleLobbyHistory}>
					{
						// History button
						lobbyHistory ?
							<img src={small_history_on} alt="history" /> :
							<img src={small_history_off} alt="history" />
					}
				</div>

				<div {...pcodeProp} onClick={toggleLobbyMinMax}>
					{
						// Min-max button
						lobbyMinMax ?
							<img src={small_minmax_on} alt="min-max" /> :
							<img src={small_minmax_off} alt="min-max" />
					}
				</div>
			</div>
		);
	}

	render() {
		const { activeGame, basePcode, pcode } = this;
		const { lang } = this.props;

		const classNames = [
			"sl-game",

			activeGame.maximised
				? "sl-single-game"
				: "sl-multi-table",

			isBigChipGame(basePcode)
				? "big-chips"
				: "",

			activeGame.transparentChips
				? "transparent-chips"
				: ""
		].join(" ");

		if (!activeGame.active)
			return null;

		return (
			<div className={classNames}

				// for auto-resize
				{...{ "data-pcode": pcode }}>

				{this.headerFragment}

				<div className="min">
					{this.streamingFragment}
					{this.streamingQualityButtonFragment}

					{this.winNumberGifFragment}

					{this.roadmapContainerFragment}
					{this.totalBetWinFragment}
					{this.gameTimerFragment}

					{this.singleGameHistoryStatisticsFragment}
					{this.singleGameSpecialStatisticsFragment}
					{this.singleGameTableDescFragment}

					{this.multiTableHistoryButtonFragment}
					{this.multiTableRoadmapOptionsFragment}
					{this.multiTableRoadmapFragment}
					{this.multiTableMinMaxHistoryFragment}
				</div>

				<div className="max">
					{this.gameTableFragment}
					{this.gameControllerFragment}
				</div>

				{this.sicboMachineVirtualBallFragment}
				{this.samGongVirtualBallFragment}

				{
					renderModals(
						activeGame,
						lang.language_code,
						this.props.clearModalsWithPcode
					)
				}

				{this.moreBetButtonFragment}
			</div>
		);
	}
}
